import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from '@alefeducation/ui-elements-library-core';
import { Download } from '@alefeducation/ui-elements-library-icons';
import { ButtonContainer } from '../common/AssignmentPageLayout/AssignmentPageLayout';
import {
  getDownloadableFileLink,
  getFileLink,
} from '../AssignmentSubmission/attachment.utils';
import AssignmentContext from '../common/AssignmentContext/AssignmentContext';

const DownloadAttachmentButton = ({ attachment, fileNameSuffix }) => {
  const { t } = useTranslation();
  const {
    assignmentData: { assignmentType },
  } = useContext(AssignmentContext);
  const assignmentTypeForPendoClass = assignmentType
    .split('_')
    .join('-')
    .toLowerCase();
  return (
    <ButtonContainer>
      <Button
        data-testid="student-attachment-download-button"
        icon={<Download fontSize={18} />}
        variant="secondary"
        className={`data-analytics-${assignmentTypeForPendoClass}-student-assignment-submission-page-download-attachment`}
        size="lg"
        onClick={() =>
          window.open(
            getDownloadableFileLink(
              getFileLink(attachment),
              attachment.fileName,
              fileNameSuffix,
            ),
            '_blank',
          )
        }
      >
        {t('Download')}
      </Button>
    </ButtonContainer>
  );
};

DownloadAttachmentButton.defaultProps = {
  fileNameSuffix: '',
};

DownloadAttachmentButton.propTypes = {
  attachment: PropTypes.object.isRequired,
  fileNameSuffix: PropTypes.string,
};

export default DownloadAttachmentButton;
